module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/august/mainvisual-title_0b54678813861e6c44a34920f17bc6dd.png";